var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widget_box" }, [
    _vm.showSeoUrl
      ? _c("div", { staticClass: "show-widget-border" }, [
          _c("div", { staticClass: "show-widget-title" }, [
            _vm._v("Integrate to your website")
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "show-widget-second" }, [
            _c("div", { staticClass: "show-widget-second-title" }, [
              _vm._v("Embed a ViLocal Widget")
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "show-widget-second-step1-content" },
              [
                _c("el-divider", { attrs: { direction: "vertical" } }),
                _vm._v(" "),
                _c("div", { staticClass: "show-widget-second-step1-text" }, [
                  _vm._v(_vm._s(_vm.content))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "show-widget-copy-border",
                    on: {
                      click: function($event) {
                        return _vm.copy($event)
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-copy-document",
                      staticStyle: { color: "#262B2F", "margin-right": "15px" }
                    }),
                    _vm._v("Copy code")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "show-widget-second-step2-content" }, [
              _vm._v("In the HTML/code editor, paste your iframe code.  ")
            ]),
            _vm._v(" "),
            _vm._m(3)
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "show-widget-title",
              staticStyle: { "margin-top": "30px" }
            },
            [_vm._v("Wdiget Usage Guide")]
          ),
          _vm._v(" "),
          _c("iframe", {
            staticStyle: {
              height: "514px",
              width: "100%",
              margin: "0px auto",
              "margin-top": "20px",
              border: "none"
            },
            attrs: { src: _vm.brandSeoUrl }
          }),
          _vm._v(" "),
          false
            ? _c("div", { staticClass: "show-widget-title" }, [
                _vm._v("Examples after embedding")
              ])
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c("div", { staticClass: "show-widget-bottom-img" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/widget/widget-bottom.png")
                  }
                })
              ])
            : _vm._e()
        ])
      : _c("div", { staticClass: "hidden-widget-border" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/widget/hidden-widget.png") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "hidden-widget-border-text" }, [
            _vm._v(
              "Your brand’s widget has not been generated yet. You will be nottified via email once it is generated. Please keep an eye on yourinbox"
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "show-widget-first" }, [
      _c("div", { staticClass: "show-widget-first-img" }, [
        _c("img", {
          staticStyle: { width: "100%", height: "100%" },
          attrs: { src: require("@/assets/img/widget/show-widget-first.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "show-widget-first-right" }, [
        _c("div", { staticClass: "show-widget-first-right-title" }, [
          _vm._v("Embed a ShopVidi Widget")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "show-widget-first-right-content" }, [
          _vm._v(
            "ViLocal widget is a piece of code embedded in the website, ViLocal product service, we can help brands enter the store for trial sales, and enjoy the exclusive service provided by ShopVidi, online users provide offline purchase scenes, to achieve the effect of offline Showroom"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "show-widget-first-right-work" }, [
          _vm._v("How it works"),
          _c(
            "a",
            {
              staticClass: "show-widget-first-right-work-link",
              attrs: {
                target: "_blank",
                href:
                  "https://help.shopvidi.com/en/articles/8539436-vilocal-module-embedding-site-operation-guide"
              }
            },
            [_vm._v("Widget Usage Guide")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "show-widget-first-right-bottom" }, [
          _vm._v(
            "Just embed our widget or button on your website and your customers can browse"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "show-widget-second-step1" }, [
      _c("div", { staticClass: "show-widget-second-step1-title" }, [
        _vm._v("1")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "show-widget-second-step1-subtitle" }, [
        _vm._v("Copy the ViLocal code")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "show-widget-second-step2" }, [
      _c("div", { staticClass: "show-widget-second-step2-title" }, [
        _vm._v("2")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "show-widget-second-step2-subtitle" }, [
        _vm._v(
          "Embed ViLocal module into Shopify、official website and other official websites"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "show-widget-second-step2-img" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/widget/widget-middle.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b91b59f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b91b59f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vilocal/widget.vue
// module id = MzFv
// module chunks = 2